import { call, put } from 'redux-saga/effects';
import { BACKEND_URL, CLOAK_CALLBACK, FRONT_URL } from '../../../configs';
import { authorizedLoginFailed, authorizedLoginSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* authorizedLogin(action) {
  try {
    const login = yield window.keycloak.login({ redirectUri: FRONT_URL });
  } catch (e) {
    yield put(authorizedLoginFailed(e));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
